import React from 'react';
import SEO from '../components/SEO';
import '../components/home/HomePage.css';
import HomeHeroSection from '../components/home/HomeHeroSection';
import HomeRatingsSection from '../components/home/HomeRatingsSection';
import HomeProofSection from '../components/home/HomeProofSection';
import HomeFlagshipSection from '../components/home/HomeFlagshipSection';
import HomeApproachSection from '../components/home/HomeApproachSection';
import HomeAgenticSection from '../components/home/HomeAgenticSection';
import HomeFounderSection from '../components/home/HomeFounderSection';
import HomeCareerSection from '../components/home/HomeCareerSection';
import HomeCertificationsSection from '../components/home/HomeCertificationsSection';
import HomeJobsTeaserSection from '../components/home/HomeJobsTeaserSection';
import HomeEventsSection from '../components/home/HomeEventsSection';
import HomeTestimonialsSection from '../components/home/HomeTestimonialsSection';
import HomeNewsletterSection from '../components/home/HomeNewsletterSection';
import HomeFloatingUI from '../components/home/HomeFloatingUI';

function Home() {
  return (
    <main className="nh-home">
      <SEO pageName="home" />
      <HomeHeroSection />
      <HomeRatingsSection />
      <HomeProofSection />
      <HomeFlagshipSection />
      <HomeApproachSection />
      <HomeAgenticSection />
      <HomeFounderSection />
      <HomeCareerSection />
      <HomeCertificationsSection />
      <HomeJobsTeaserSection />
      <HomeEventsSection />
       
      <HomeNewsletterSection />
      <HomeFloatingUI />
    </main>
  );
}

export default Home;
